import { OverlayTrigger, Popover } from "react-bootstrap";

const ConditionalPopover = ({
    condition,
    placement,
    popover,
    children,
}) => {

    if(condition){
        return (
            <OverlayTrigger
                placement={placement}
                overlay={popover}
            >
                {children}
            </OverlayTrigger>
        );
    }

    return children;

};

export default ConditionalPopover;